import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header justify-content-center mt-2" }
const _hoisted_2 = { class: "modal-body mx-4" }
const _hoisted_3 = { class: "d-flex justify-content-end m-3 mt-4" }

import { computed } from "vue"
import { GDialog } from 'gitart-vue-dialog'

type Props = {
  modelValue: boolean,
  title?: string,
  titleClass?: string,
  modalMaxWidth?: string,
  contentClass?: string,
  width?: string,
};


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterModal',
  props: {
    modelValue: { type: Boolean },
    title: { default: "" },
    titleClass: { default: 'confirmation-modal-title' },
    modalMaxWidth: {},
    contentClass: { default: 'confirmation-modal-note' },
    width: { default: '50%' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(GDialog), {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    "max-width": props.modalMaxWidth,
    transition: "custom-from-bottom-transition",
    persistent: true,
    width: props.width
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "flash-message"),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", {
          class: _normalizeClass(props.titleClass)
        }, _toDisplayString(__props.title), 3)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(props.contentClass)
        }, [
          _renderSlot(_ctx.$slots, "content")
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "buttons")
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "max-width", "width"]))
}
}

})